import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { Box, Typography } from "@mui/material";

interface TitleAndText {
  tooltipTitle?: string;
  tooltipText?: string;
}

interface TooltipProps {
  titlesAndTexts?: TitleAndText[];
  children: React.ReactElement<any, any>;
}

const titleStyle = {
  color: "black",
  fontFamily: "Lato",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "bold",
  marginBottom: 1,
};

const textStyle = {
  color: "black",
  fontFamily: "Lato",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  marginBottom: 1,
};

const HoverTooltip: React.FC<TooltipProps> = ({ titlesAndTexts, children }) => {
  return (
    <Tooltip
      title={
        <Box>
          {titlesAndTexts?.map(({ tooltipTitle, tooltipText }, index) => (
            <div key={index}>
              <Typography variant="body1" {...titleStyle}>
                {tooltipTitle}
              </Typography>
              <Typography variant="body1" {...textStyle}>
                {tooltipText}
              </Typography>
            </div>
          ))}
        </Box>
      }
      followCursor
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            color: "black",
            bgcolor: "#EAEEF4",
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default HoverTooltip;
